import { useRouterHistory } from "react-router";
import { createHistory } from "history";
import CountryUtil from "./utils/CountryUtil";
import FeatureSessionStore from "./stores/FeatureSessionStore";

let history: History | null = null;
let location: Location | null = null;

// keep in sync with InjectorReplacer.java (see MSD-1552)
const possibleBaseNames = [
	"/ordercapture/uidispatcher/static/shop",
	"/ordercapture/uidispatcher/static/backend",
	"/shop/fsd",
	"/backend/fsd",
	"/shop/store",
	"/backend/store",
	"/shop",
	"/backend",
];
const shopRegex = /^(\/ordercapture\/uidispatcher\/static)?\/shop/;
// keep in sync with InjectorReplacer.java (see MSD-1552)
const flavorRegexes = {
	fsd: /^(\/shop|\/backend)\/fsd/,
	store: /^(\/shop|\/backend)\/store/,
};

function isMetroX() {
	return FeatureSessionStore.getMembershipFor("METRO_X") === "B";
}

function getBaseName(pathname: string = window.location.pathname): string {
	for (const baseName of possibleBaseNames) {
		if (pathname === baseName || pathname?.startsWith(baseName + "/")) {
			return baseName;
		}
	}

	return possibleBaseNames[0];
}

// Let's make history!
function makeHistory() {
	const basename = getBaseName();
	const history = useRouterHistory(createHistory)({
		basename: basename,
	});
	location = history.getCurrentLocation();
	history.listen(loc => {
		location = loc;
	});
	return history;
}

function getHistory(): any {
	if (history === null) {
		history = makeHistory();
	}

	return history;
}

function checkHashRedirect() {
	if (RegExp(/^#\/.*/).exec(window.location.hash)) {
		const path = window.location.hash.substring(1);
		console.error("Detected hash location, redirecting to correct URL", path);
		getHistory().replace(path);
	}
}

function installHashRedirect() {
	window.addEventListener("hashchange", checkHashRedirect);
	checkHashRedirect();
}

function getShopFlavor(): any {
	const baseName = getBaseName();

	for (const flavor in flavorRegexes) {
		if (baseName.match(flavorRegexes[flavor])) {
			return flavor;
		}
	}

	const config = CountryUtil.getOptionalConfig();

	// Domain-based flavors are only applied if the feature toggle is on
	if (isMetroX() && config && config.domainFlavors) {
		const domain = window.location.hostname.toLowerCase();

		if (domain in config.domainFlavors) {
			return config.domainFlavors[domain];
		}
	}

	return null;
}

function isBackend(pathname: string = window.location.pathname): any {
	return !pathname.match(shopRegex);
}

function toBackend(pathname: string = window.location.pathname): any {
	return pathname.replace(/\/shop/, "/backend");
}

function toShop(pathname: string = window.location.pathname): any {
	return pathname.replace(/\/backend/, "/shop");
}

const bettyHistoryModule = {
	get: getHistory,
	getBaseName,
	installHashRedirect,

	get location() {
		return location;
	},

	get pathname(): string | null {
		if (location) {
			return location.pathname;
		}

		return null;
	},

	push(path: string, state?: any): Record<string, any> {
		return getHistory().push(path, state);
	},

	getShopFlavor,
	isBackend,
	toBackend,
	toShop,
	_forTesting: {
		reset() {
			history = null;
			location = null;
		},
	},
};
export default bettyHistoryModule;
